<div mat-dialog-content class="text-center d-flex flex-column justify-content-center align-items-center">
    <img [src]="data?.imgUrl" alt="img">
    <p class="h4 mt-3 text-dark fw-semibold">{{data?.title}}</p>
    <p style="color: #7094D1;" class="fw-semibold">{{data?.shortDesc}}</p>
    <p class="text-dark">{{data?.longDesc}}</p>
  </div>
  <div mat-dialog-actions class="d-flex flex-row justify-content-center align-items-center mb-3">
    <button (click)="onClose()" mat-stroked-button color="primary" class="close-btn rounded-5 me-3">{{data?.closeButtonName}}</button>
    <button (click)="onProceed()" mat-flat-button color="primary" class="proceed-btn rounded-5">{{data?.submitButtonName}}</button>
</div>